
import { Options } from "vue-class-component";


import AppUtil from "@/util/AppUtil";

import BasePage from "@/common/BasePage";

@Options({
  components: {

  },
})
/**超级会员管家 */
export default class PackageList extends BasePage {
 _title="超级会员管家";
 backcolor="white"
 data={
     housekeeperHeadimg:"",
     housekeeperName:"正在加载...",
     housekeeperPhone:"",
     housekeeperQrcode:""
 }
 mounted() {
  AppUtil.request({url:"/zhShareholder/shareholder/getHousekeeperInfo",method:"post"},this.get_info_ok)   
 }
 get_info_ok(res:any){
console.log("管家信息",res);
this.data=res.data
 }
 tel_click() {
    window.location.href = "tel:" + this.data.housekeeperPhone;
  }
}
